import { useEffect } from 'react'

export function useTitleChange(title: string) {
  useEffect(() => {
    document.title = title
  }, [title])
}
